import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import Styled from 'styled-components';
import InfoMessages from './InfoMessages';

function InfoMessagesModal({ show, onHide, className }) {
  return (
    <Modal show={show} onHide={onHide} className={className}>
      <Modal.Header>
        <h3 className="text-center">
          <span>ACH Payments Info</span>
        </h3>
        <Button onClick={onHide}>X</Button>
      </Modal.Header>
      <Modal.Body>
        <InfoMessages />
      </Modal.Body>
    </Modal>
  );
}

export default Styled(InfoMessagesModal)`
  .modal-header {
    display: flex;
  }
  .modal-header button  {
    margin-left: auto;
    align-self: center;
  }
`;
